module.exports = __webpack_public_path__ + "img/reg21.9ba2d863.png";